import React from "react";

// ** Icons
import CheckDecagram from "mdi-material-ui/CheckDecagram";
import PhoneOutline from "mdi-material-ui/PhoneOutline";
import MapMarkerOutline from "mdi-material-ui/MapMarkerOutline";
import TranslateVariant from "mdi-material-ui/TranslateVariant";

// ** Avatar helper & auth
import getAvatarPicture from "src/@core/components/profile";
import { useAuth } from "src/hooks/useAuth";

/******************************************************************
 * ##: ShowUserInfo
 * Identity card (style-v3): avatar, name, e-mail, a "Verificado"
 * badge and the account detail rows (phone, country, language).
 * Read-only, mirroring the data previously shown here.
 * @returns {JSX.Element} - the `.spv3-idcard` identity card
 * History:
 * 05-07-2026: Rebuilt with style-v3 (was a MUI CardContent block)
 ******************************************************************/
function ShowUserInfo() {
  const auth = useAuth();
  const user = auth?.user;

  return (
    <div className="spv3-idcard">
      <span className="spv3-idcard__glow" />

      <img className="spv3-idcard__avatar" alt={user?.name} src={getAvatarPicture(user?.name)} />
      <h2 className="spv3-idcard__name">{user?.name}</h2>
      <p className="spv3-idcard__email">{user?.email}</p>

      <span className="spv3-pill spv3-pill--success">
        <CheckDecagram />
        Verificado
      </span>

      <div className="spv3-idcard__divider" />

      <dl className="spv3-details">
        <Detail icon={<PhoneOutline />} label="Telefone" value={user?.phone || "Não definido"} />
        <Detail icon={<MapMarkerOutline />} label="País" value={user?.country || "Não definido"} />
        <Detail icon={<TranslateVariant />} label="Idioma" value="Português" />
      </dl>
    </div>
  );
}

// HELPERS

/******************************************************************
 * ##: Detail
 * One labelled detail row (icon + label + value) in the identity card.
 * @param {Object} props - icon / label / value
 * @returns {JSX.Element} - a `.spv3-detail` row
 * History:
 * 05-07-2026: Created
 ******************************************************************/
const Detail = ({ icon, label, value }) => (
  <div className="spv3-detail">
    <span className="spv3-detail__icon">{icon}</span>
    <span className="spv3-detail__body">
      <span className="spv3-detail__label">{label}</span>
      <span className="spv3-detail__value">{value}</span>
    </span>
  </div>
);

export default ShowUserInfo;
